import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Button, Form, Spin, message, Tabs } from 'antd';
import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import axios from '../utils/axios';
import BreadCrumb from '../components/Breadcrumb';
import Itinerary from '../components/event/Itinerary';
import Details from '../components/event/Details';
import Packages from '../components/event/Packages';
import Batches from '../components/event/Batches';
import Pickuplocation from '../components/event/PickupLocation';
import TripInformation from '../components/event/TripInformation';
import ClientsReviews from '../components/event/ClientsReviews';


function EventAddEdit() {
	const navigate = useNavigate();
	const { editEventId } = useParams();
	const [isLoading, setIsLoading] = useState(false);
	const [fileList, setFileList] = useState([]);
	const [form] = Form.useForm();

	const get = () => {
		if (!editEventId) {
			return;
		}
		setIsLoading(true);
		axios
			.get(`/event`, { params: { _id: editEventId } })
			.then((result) => {
				if (Array.isArray(result.data.data) && result.data.data.length) {
					const [data] = result.data.data;
					if (data?.otherDetails?.delta) {
						data.otherDetails.delta = JSON.parse(data.otherDetails.delta);
					}

					data.batches.forEach((batch) => {
						batch.batchStartEndDateTime = [dayjs(batch.batchStartsAt), dayjs(batch.batchEndsAt)];
					});

					// if (Array.isArray(data?.defaultPickuplocation)) {
					// 	data.defaultPickuplocation = data.defaultPickuplocation.map((pickup) => {
					// 		if (pickup.pickupStartsAt && pickup.pickupEndsAt) {
					// 			pickup.pickupStartEndDateTime = [dayjs(pickup.pickupStartsAt), dayjs(pickup.pickupEndsAt)];
					// 		}
					// 		return pickup;
					// 	});
					// }

					const uplodedFileList = data?.media?.map((media) => ({
						uid: media._id,
						name: media.mediaTitle,
						status: 'done',
						url: media.mediaPath,
					}));
					if (Array.isArray(uplodedFileList)) {
						setFileList(uplodedFileList);
					}
					form.setFieldsValue(data);
				}
			})
			.catch(() => {})
			.finally(() => {
				setIsLoading(false);
			});
	};

	const onSave = () => {
		form.validateFields()
			.then((values) => {
				console.log('Event Values:', values);
				setIsLoading(true);
				if (editEventId) {
					values._id = editEventId;
				}
				if (values?.title) {
					const slugText = values.title
						.toLocaleLowerCase()
						.replace(/\s+/g, '-')
						.replace(/-+/g, '-')
						.replace(/^-+|-+$/g, '');
					values.slug = slugText;
				}

				if (values?.otherDetails?.delta) {
					values.otherDetails.delta = JSON.stringify(values.otherDetails.delta);
				}

				const media = [];
				fileList?.map(({ response }) => {
					if (response?.data?.length) {
						media.push(...response.data);
					}
					return response;
				});
				if (media.length) {
					values.media = media;
				}

				// if (Array.isArray(values.batches)) {
				// 	values.batches = values.batches.map((batch) => {
				// 		batch.batchStartsAt = batch.batchStartEndDateTime[0];
				// 		batch.batchEndsAt = batch.batchStartEndDateTime[1];
				// 		return batch;
				// 	});
				// }

				// if (Array.isArray(values.defaultPickuplocation)) {
				// 	values.defaultPickuplocation = values.defaultPickuplocation.map((pickup) => {
				// 		if (pickup.pickupStartEndDateTime) {
				// 			pickup.pickupStartsAt = pickup.pickupStartEndDateTime[0];
				// 			pickup.pickupEndsAt = pickup.pickupStartEndDateTime[1];
				// 		}
				// 		return pickup;
				// 	});
				// }
				if (Array.isArray(values.batches)) {
					values.batches = values.batches.map((batch) => {
						const [batchStartsAt, batchEndsAt] = batch.batchStartEndDateTime;
						return {
							...batch,
							batchStartsAt,
							batchEndsAt,
						};
					});
				}

				// if (Array.isArray(values.defaultPickuplocation)) {
				// 	values.defaultPickuplocation = values.defaultPickuplocation.map((pickup) => {
				// 		if (pickup.pickupStartEndDateTime) {
				// 			const [pickupStartsAt, pickupEndsAt] = pickup.pickupStartEndDateTime;
				// 			return {
				// 				...pickup,
				// 				pickupStartsAt,
				// 				pickupEndsAt,
				// 			};
				// 		}
				// 		return pickup;
				// 	});
				// }

				console.log('slug:', values.slug);
				axios({
					method: editEventId ? 'put' : 'post',
					url: '/event',
					data: values,
				})
					.then((result) => {
						if (result.data.success) {
							message.success(result.data.message);
							navigate('/events');
						} else {
							message.error(result.data.message);
							setIsLoading(false);
						}
					})
					.catch(() => {
						message.error('Oops! Something went wrong!');
						setIsLoading(false);
					});
			})
			.catch((e) => {
				console.log(e);
			});
	};

	useEffect(() => {
		get();
	}, []);

	return (
		<>
			<BreadCrumb
				breadcrumbs={[
					{
						link: '/',
						label: 'Home',
					},
					{
						label: 'Events',
					},
				]}
			/>
			<Spin spinning={isLoading}>
				<div className='main-content'>
					<div className='page-header'>
						<div className='page-title'>Add Event</div>
						<div className='page-title-more'>
							<Link to='/events'>
								<Button icon={<ArrowLeftOutlined />}>Back</Button>
							</Link>
							<Button icon={<SaveOutlined />} type='primary' onClick={onSave}>
								Save
							</Button>
						</div>
					</div>
					<div className='form-content'>
						<Form form={form} layout='vertical' autoComplete='off'>
							<Tabs
								defaultActiveKey='1'
								items={[
									{
										key: 'Details',
										label: 'Details',
										children: <Details Form={Form} getFieldValue={form.getFieldValue} setFieldValue={form.setFieldValue} fileList={fileList} setFileList={setFileList} />,
									},
									{
										key: 'Batches',
										label: 'Batches',
										children: <Batches Form={Form} />,
									},
									{
										key: 'Itinerary',
										label: 'Itinerary',
										children: <Itinerary Form={Form} />,
									},
									{
										key: 'Costing Details',
										label: 'Costing Details',
										children: <Packages Form={Form} />,
									},
									{
										key: 'Pickup Location',
										label: 'Pickup Location',
										children: <Pickuplocation Form={Form} />,
									},
									{
										key: 'Trip Information',
										label: 'Trip Information',
										children: <TripInformation Form={Form} />,
									},
									{
										key: 'Clients Reviews',
										label: 'Clients Reviews',
										children: <ClientsReviews Form={Form} />,
									},
								]}
							/>
						</Form>
					</div>
				</div>
			</Spin>
		</>
	);
}

export default EventAddEdit;
